import { createDateTimeColumn } from '@app/components/date/create-date-time-column';
import { ShowOnStreamAction } from '@app/modules/audit/components/ShowOnStreamAction';
import { ReportResultProps } from '@app/core/reports/types';
import { Seconds, toTimestamp } from '@mi-front/core';
import { Duration, MrtTable } from '@mi-front/ui';
import { useIntl } from 'react-intl';
import { LowerthirdReport, LowerthirdType } from '../../../../types';

export function LowerthirdResult({
  values,
  result,
  isLoading,
}: ReportResultProps<LowerthirdReport>) {
  const { formatMessage } = useIntl();

  return (
    <MrtTable<LowerthirdType>
      columns={[
        createDateTimeColumn<LowerthirdType>(formatMessage, {
          id: 'time',
          accessor: (row) => row.from,
        }),
        {
          id: 'text',
          enableSorting: false,
          accessorFn: (row) => row.text,
          header: formatMessage({
            id: 'audit.lowerthird.title',
            defaultMessage: 'Zocalos',
          }),
          size: 200,
        },
        {
          id: 'duration',
          header: formatMessage({
            id: 'audit.lowerthird.duration',
            defaultMessage: 'Duración',
          }),
          Cell: ({ row: { original } }) => (
            <div>
              <Duration
                seconds={
                  ((toTimestamp(original.to) - toTimestamp(original.from)) / 1000) as Seconds
                }
              />
            </div>
          ),
          enableSorting: true,
          size: 30,
        },
        {
          id: 'actions',
          enableSorting: false,
          accessorFn: () => '',
          header: formatMessage({
            id: 'common.text.actions',
            defaultMessage: 'Acciones',
          }),

          size: 30,
          Cell: ({ row }) => (
            <ShowOnStreamAction
              station={values.station.slug}
              datetime={row.original.from}
              endDatetime={row.original.to}
              tab="lowerthird"
              variant="link"
            />
          ),
        },
      ]}
      data={result}
      enableExpandAll={false}
      enableGlobalFilter={false}
      enableFilters={false}
      memoizeColumns={false}
      enableHiding={false}
      enableColumnActions={false}
      state={{
        isLoading,
      }}
    />
  );
}
